import labelControl from './reportLabel';

export default {
    render: function(def, ctx, callback) {
        let cellIdx = 0;
        let cell = null;

        function renderCell(){
            cell = def.Cells[cellIdx++];
            if (cell != null){
                labelControl.render(cell, ctx, renderCell);
            }
            else {
                callback();
            }
        }

        if (def.Cells.any()){
            renderCell();
        }
        else {
            callback();
        }
    },
    preRender: function(def, ctx, callback) {
        if (def.runTime == null){
            def.runTime = {
                height: def.Height,
                top: def.Top,
                grown: false
            };
        }
        else {
            def.runTime.height = def.Height;
            def.runTime.top = def.Top;
            def.runTime.grown = false;
        }

        let cellIdx = 0;
        let cell = null;

        function preRenderCell(){
            cell = def.Cells[cellIdx++];
            if (cell != null){
                labelControl.preRender(cell, ctx, preRenderCell);
            }
            else {
                //Since this is a table row, the highest control makes all of them the same...EK
                let maxHeight = def.Cells.select(c => c.runTime.height).max();

                if (maxHeight > def.runTime.height){
                    //This table row must grow to fit it's contents... set the height and that we have grown...EK
                    def.Cells.forEach(c => c.runTime.height = maxHeight );
                    def.runTime.height = maxHeight;
                    // def.runTime.grown = true;        // Note!!! We don't want to flag as grown as we don't want table rows to apply to growth logic for normal fields (they are handled internally) ... EK
                }
                callback();
            }
        }

        if (def.Cells.any()){
            preRenderCell();
        }
        else {
            callback();
        }
    }
};
